import { TREE } from 'consts'
import React, { useState } from 'react'
import Particles from 'react-particles-js'
import styled from 'styled-components'
import { Tree } from 'types'
import { particlesOptions } from 'utils/bg'

import Intro from './Intro'
import Result from './Result'
import Step from './Step'

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`
const Bg = styled(Particles).attrs({ params: particlesOptions })`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: -1;
`
const Content = styled.div`
  width: 100%;
  max-width: 500px;
  margin: 16px;
  align-items: center;

  > div {
    width: 100%;
  }
`

type Status =
  | { tag: 'intro' }
  | { tag: 'step'; tree: Tree; prevStatus: Status; stepIdx: number }

const App: React.FC = () => {
  const [status, setStatus] = useState<Status>({ tag: 'intro' })

  return (
    <Container>
      <Bg />
      <Content>
        {status.tag === 'intro' && (
          <Intro
            onPressStart={() =>
              setStatus({
                tag: 'step',
                tree: TREE,
                prevStatus: { tag: 'intro' },
                stepIdx: 0,
              })
            }
          />
        )}
        {status.tag === 'step' && status.tree.tag === 'branch' && (
          <Step
            tree={status.tree}
            idx={status.stepIdx}
            onPressNext={nextTree =>
              setStatus({
                tag: 'step',
                tree: nextTree,
                prevStatus: status,
                stepIdx: status.stepIdx + 1,
              })
            }
            onPressPrev={() => setStatus(status.prevStatus)}
          />
        )}
        {status.tag === 'step' && status.tree.tag === 'leaf' && (
          <Result
            tree={status.tree}
            onPressBackToIntro={() => setStatus({ tag: 'intro' })}
          />
        )}
      </Content>
    </Container>
  )
}

export default App
